(() => {
  const KLAVIYO_REVISION = '2024-10-15';

  document.querySelectorAll('[data-product-waitlist-form]').forEach((form) => {
    if (form.dataset.waitlistBound === 'true') return;
    form.dataset.waitlistBound = 'true';

    const companyId = form.dataset.klaviyoCompanyId;
    const listId = form.dataset.klaviyoListId;
    const successMessage = form.dataset.successMessage;
    const errorMessage = form.dataset.errorMessage;
    const emailInput = form.querySelector('[data-waitlist-email]');
    const submitButton = form.querySelector('[data-waitlist-submit]');
    const successEl = form.querySelector('[data-waitlist-success]');
    const errorEl = form.querySelector('[data-waitlist-error]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!companyId || !listId) {
        if (errorEl) {
          errorEl.textContent = 'Klaviyo is not configured. Add your public API key and list ID in the theme editor.';
          errorEl.hidden = false;
        }
        return;
      }

      const email = emailInput?.value?.trim();
      if (!email) return;

      submitButton?.setAttribute('aria-disabled', 'true');
      submitButton?.classList.add('loading');
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: form.dataset.customSource || 'Product Waitlist',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: listId,
                    },
                  },
                },
              },
            }),
          }
        );

        if (response.ok || response.status === 202) {
          if (successEl) {
            successEl.textContent = successMessage;
            successEl.hidden = false;
          }
          form.reset();
          emailInput?.blur();
          return;
        }

        let message = errorMessage;
        try {
          const data = await response.json();
          if (data?.errors?.[0]?.detail) {
            message = data.errors[0].detail;
          }
        } catch (parseError) {
          /* use default error message */
        }

        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        }
      } catch (error) {
        console.error(error);
        if (errorEl) {
          errorEl.textContent = errorMessage;
          errorEl.hidden = false;
        }
      } finally {
        submitButton?.classList.remove('loading');
        submitButton?.removeAttribute('aria-disabled');
      }
    });
  });
})();
